const ACTIVE_CLASS = 'mobile-navigation__menu--active';

const mobileInit = () => {
  const toggler : HTMLElement = document.querySelector('.mobile-navigation__toggler');
  const menu : HTMLElement = document.querySelector('.mobile-navigation__menu');

  toggler.addEventListener('click', () => {
    menu.classList.toggle(ACTIVE_CLASS);
  });
};

export default mobileInit;
